// extracted by mini-css-extract-plugin
export default {"container":"Header_container__TsUVY","header":"Header_header__OKWO7"};